import * as angular from 'angular';

const SPINNER_START = 'SpinnerStart';
const SPINNER_STOP = 'SpinnerStop';

class SpinnerService {
  scope: any;

  constructor($rootScope) {
    this.scope = $rootScope;
  }

  start() {
    this.scope.$broadcast(SPINNER_START, true);
  }

  stop() {
    this.scope.$broadcast(SPINNER_STOP, true);
  }

  onStart(listener: () => any) {
    return this.scope.$on(SPINNER_START, listener);
  }

  onStop(listener: () => any) {
    return this.scope.$on(SPINNER_STOP, listener);
  }
}

export default SpinnerService;

angular.module('ciApp').service('SpinnerService', ['$rootScope', SpinnerService]);



// WEBPACK FOOTER //
// ./common/components/spinner/spinner.service.ts